import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth-routes/admin/programLabels')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/programLabel' })
  },
})
